module.exports = {
  nowSelling: {
    active: true,
    label: 'Live',
    livingOption: {
      active: true,
      label: 'Neighbourhood'
    },
    subsectionGroup: {
      active: false,
      label: 'Release Group'
    },
    subsection: {
      active: true,
      label: 'Release'
    },
    property: {
      active: true,
      label: 'Lot'
    },
    propertyModel: {
      active: true,
      label: 'House Design'
    },
    package: {
      active: true,
      label: 'House and Land Packages'
    }
  }
}